import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { endpoint } from "../../../utils/constants/endpoint";
import { headersBase, headersType } from "../../../utils/constants/headersForApi";

export const userPracticesApi = createApi({
  reducerPath: "userPractices",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getPracticeManagement: builder.query({
      query: ({ page, filter, orderDirection = "desc",
        valueToOrderBy = "createdAt", }) => ({
          url: `${endpoint.USER_PRACTICES.PRACTICES}?status=${filter.status}&startDate=${filter.startDate}&endDate=${filter.endDate}`,
          method: "POST",
          headers: headersType(),
          body: {
            startRow: page.startRow,
            endRow: page.endRow,
            sort: [
              {
                colId: valueToOrderBy,
                sortDirection: orderDirection,
                sortIndex: 0,
              },
            ],
          },
        }),
      providesTags: ["practice"],
    }),
    getPracticeById: builder.query({
      query: (id) => ({
        url: "practices/" + id,
        method: "GET",
        headers: headersBase(),
      }),
      providesTags: ["practice"],
    }),
    getDocuments: builder.query({
      query: (id) => ({
        url: "/practices/" + id + "/doccategories",
        method: "GET",
        headers: headersBase(),
      }),
      providesTags: ["documents"],
    }),
    getUserDocuments: builder.query({
      query: ({
        id,
        filter = {
          mainCategoryId: "",
          categoryId: "",
          exclusive: false,
        },
        page,
      }) => ({
        url: `/practices/${id}/documents/list?mainCategoryId=${filter.mainCategoryId}&categoryId=${filter.categoryId}&exclusive=${filter.exclusive}`,
        method: "POST",
        headers: headersType(),
        body: { startRow: page.startRow, endRow: page.endRow },
      }),
      providesTags: ["documents"],
    }),
    getBookings: builder.query({
      query: (cf) => ({
        url: `Openbox/getBookings?codiceFiscale=${cf}`,
        method: "GET",
        headers: headersBase(),
      }),
      providesTags: ["book"]
    }),
    getBookingId: builder.query({
      query: (id) => ({
        url: `Openbox/getBookings/${id}`,
        method: "GET",
        headers: headersBase(),
      }),
      providesTags: ["book"]
    }),
    bookSpazio: builder.mutation({
      query: (book) => ({
        url: `/practices/serviceRequest`,
        method: "POST",
        headers: headersType(),
        body: book,

      }),
      invalidatesTags: ["practice"]
    }),

    editBookSpazio: builder.mutation({
      query: ({ book }) => ({
        url: `Openbox/editBooking?prenotazioneId=${book.prenotazioneId}&spotId=${book.spotId}&practiceId=${book.practiceId}`,
        method: "POST",
        headers: headersType(),
        body: book,

      }),
      invalidatesTags: ["practice", "book"]
    }),

    deleteBooking: builder.mutation({
      query: (id) => ({
        url: `Openbox/deleteBooking?idPrenotazione=${id}`,
        method: "DELETE",
        headers: headersBase(),
      }),
      invalidatesTags: ["practice", "book"]
    }),

    createPractice: builder.mutation({
      query: (practice) => ({
        url: `/practices/create`,
        method: "POST",
        headers: headersType(),
        body: practice,
      }),
      invalidatesTags: ["practice"],
    }),

    createPracticeDocument: builder.mutation({
      query: ({ cleanedDocumentData, praticaId }) => ({
        url: `/practices/${praticaId}/newdocument`,
        method: "POST",
        headers: headersType(),
        body: cleanedDocumentData,
      }),
      invalidatesTags: ["documents"],
    }),
    addAssociateDocument: builder.mutation({
      query: (body) => ({
        url: `/practices/${body.id}/documents`,
        method: "POST",
        headers: headersType(),
        body: body,
      }),
      invalidatesTags: ["documents"],
    }),
    deleteAssociateDocument: builder.mutation({
      query: (params) => ({
        url: `/practices/${params.practiceId}/documents/${params.documentId}`,
        method: "DELETE",
        headers: headersBase(),
        body: params,
      }),
      invalidatesTags: ["documents"],
    }),

    uploadDocumentsPractice: builder.mutation({
      query: (practiceId) => ({
        url: `practices/${practiceId}/complete`,
        method: "POST",
        headers: headersType(),
        body: practiceId,
      }),
      invalidatesTags: ["practice"],
    }),
  }),
});

export const {
  useGetPracticeManagementQuery,
  useGetPracticeByIdQuery,
  useGetUserDocumentsQuery,
  useGetDocumentsQuery,
  useGetBookingsQuery,
  useGetBookingIdQuery,
  useBookSpazioMutation,
  useEditBookSpazioMutation,
  useDeleteBookingMutation,
  useCreatePracticeMutation,
  useCreatePracticeDocumentMutation,
  useAddAssociateDocumentMutation,
  useDeleteAssociateDocumentMutation,
  useUploadDocumentsPracticeMutation,
} = userPracticesApi;
